import { BusinessChecklistVM } from '@models/checklist';
import { SortOption } from './checklists.types';
import { MatterFileType } from '@models/matter';

export class Create {
	static readonly type = '[checklists] create template to business';
	constructor(
		public payload: {
			checklistItems: BusinessChecklistVM;
			oldItemIds?: string[];
		},
	) {}
}

export class SetDefault {
	static readonly type = '[checklists] set default template';
	constructor(public id: string) {}
}

export class DeleteItems {
	static readonly type = '[checklists] delete items from business';
	constructor(public ids: string[]) {}
}

export class Remove {
	static readonly type = '[checklists] remove template from business';
	constructor(public templateId: string) {}
}

export class UpdateSortOption {
	static readonly type = '[checklists] updating sort option from business';
	constructor(public payload: SortOption | null) {}
}

export class UpdateSelectedFileType {
	static readonly type =
		'[checklists] updating selected file type from business';
	constructor(public payload: MatterFileType | 'all') {}
}
